export interface RulesEditorEventErrorState {
	phoneNumbers: boolean;
	emailAddresses: boolean;
}

export interface RulesEditorErrorState {
	activationEvent: RulesEditorEventErrorState;
	deactivationEvent: RulesEditorEventErrorState;
	deviceConfig: boolean;
}

export function makeDefaultRulesEditorErrorState(): RulesEditorErrorState {
	return {
		activationEvent: {
			phoneNumbers: false,
			emailAddresses: false,
		},
		deactivationEvent: {
			phoneNumbers: false,
			emailAddresses: false,
		},
		deviceConfig: false,
	};
}

export function rulesEditorEventErrorStateHasError(
	state: RulesEditorEventErrorState,
): boolean {
	return state.phoneNumbers || state.emailAddresses;
}

export function rulesEditorErrorStateHasError(
	state: RulesEditorErrorState,
): boolean {
	return (
		rulesEditorEventErrorStateHasError(state.activationEvent) ||
		rulesEditorEventErrorStateHasError(state.deactivationEvent) ||
		state.deviceConfig
	);
}
